import * as React from 'react'

function SvgLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.095 12.232A3.085 3.085 0 0112 15.308a3.085 3.085 0 01-3.095-3.076A3.085 3.085 0 0112 9.157a3.085 3.085 0 013.095 3.075z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.552c-4.653 0-8.426 3.749-8.426 8.373a8.345 8.345 0 003.576 6.848c.807.565 1 1.673.43 2.474a1.794 1.794 0 01-2.49.428C2.015 19.52 0 15.956 0 11.925 0 5.339 5.373 0 12 0s12 5.339 12 11.925c0 4.031-2.015 7.595-5.09 9.75a1.794 1.794 0 01-2.49-.428 1.769 1.769 0 01.43-2.474 8.345 8.345 0 003.575-6.848c0-4.624-3.772-8.373-8.425-8.373z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgLogo
